<template>
  <div>
    <ClaimedModal v-if="isModalOpen('Claimed')"></ClaimedModal>
    <EditBoardMetadataModal
      v-on:done="modalsDidClose"
      v-if="isModalOpen('EditBoardMetadata')"
    ></EditBoardMetadataModal>
    <EditGuestUsernameModal
      v-on:done="modalsDidClose"
      v-if="isModalOpen('GuestUsername')"
    ></EditGuestUsernameModal>
    <ExpirationModal
      v-on:done="modalsDidClose"
      v-if="isModalOpen('Expiration')"
    ></ExpirationModal>
    <DemoModal
      v-on:done="modalsDidClose"
      v-if="isModalOpen('DemoNote')"
    ></DemoModal>
    <FeatureGateForImageUploadModal
      v-on:done="modalsDidClose"
      v-if="isModalOpen('FeatureGateForImageUpload')"
    ></FeatureGateForImageUploadModal>
    <ColorPickerModal
      v-on:done="modalsDidClose"
      setterKey="setStrokeColor"
      modalType="StrokeColor"
      v-if="isModalOpen('StrokeColor')"
    ></ColorPickerModal>
    <ColorPickerModal
      v-on:done="modalsDidClose"
      setterKey="setFillColor"
      modalType="FillColor"
      v-if="isModalOpen('FillColor')"
    ></ColorPickerModal>
    <ColorPickerModal
      v-on:done="modalsDidClose"
      setterKey="setFillColorForSticky"
      modalType="FillColorForSticky"
      v-if="isModalOpen('FillColorForSticky')"
    ></ColorPickerModal>
    <StrokeWidthPickerModal
      v-on:done="modalsDidClose"
      v-if="isModalOpen('StrokeWidth')"
    ></StrokeWidthPickerModal>
    <ImageExportModal v-if="isModalOpen('ImageExport')"></ImageExportModal>
    <ImageLibraryModal v-if="isModalOpen('ImageLibrary')"></ImageLibraryModal>
    <ImageUploadModal v-if="isModalOpen('ImageUpload')"></ImageUploadModal>
    <OKCancelModal
      v-on:ok="clearWhiteboard"
      title="Delete everything?"
      prompt="Doing this will remove all shapes from the board."
      v-if="isModalOpen('DeleteEverythingConfirmation')"
    ></OKCancelModal>
    <PDFImportModal
      :info="state.pendingPDF"
      v-if="isModalOpen('PDFImport') && state.pendingPDF"
    ></PDFImportModal>
    <ShareModal v-if="isModalOpen('Share')"></ShareModal>
  </div>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";

import ColorPickerModal from "@/components/modals/ColorPickerModal.vue";
import ClaimedModal from "@/components/modals/ClaimedModal.vue";
import DemoModal from "@/components/modals/DemoModal.vue";
import EditBoardMetadataModal from "@/components/modals/EditBoardMetadataModal.vue";
import EditGuestUsernameModal from "@/components/modals/EditGuestUsernameModal.vue";
import ExpirationModal from "@/components/modals/ExpirationModal.vue";
import FeatureGateForImageUploadModal from "@/components/modals/FeatureGateForImageUploadModal.vue";
import ImageExportModal from "@/components/modals/ImageExportModal.vue";
import ImageLibraryModal from "@/components/modals/ImageLibraryModal.vue";
import ImageUploadModal from "@/components/modals/ImageUploadModal.vue";
import OKCancelModal from "@/components/modals/OKCancelModal.vue";
import PDFImportModal from "@/components/modals/PDFImportModal.vue";
import ShareModal from "@/components/modals/ShareModal.vue";
import StrokeWidthPickerModal from "@/components/modals/StrokeWidthPickerModal.vue";

import { ModalType } from "@/store/ModalType";
import { ModalMutations } from "@/store/modules/modal";
import WBComponent from "@/WBComponent";

@Component({
  components: {
    ClaimedModal,
    ColorPickerModal,
    DemoModal,
    EditBoardMetadataModal,
    EditGuestUsernameModal,
    ExpirationModal,
    FeatureGateForImageUploadModal,
    ImageExportModal,
    ImageLibraryModal,
    ImageUploadModal,
    OKCancelModal,
    PDFImportModal,
    ShareModal,
    StrokeWidthPickerModal,
  },
})
export default class AllModals extends WBComponent {
  clearWhiteboard() {
    this.$emit("clearWhiteboard");
  }

  openModal(m: ModalType) {
    ModalMutations.openModal(this.$store.commit, m);
  }

  modalsDidClose() {
    // nothing to do, really
  }

  isModalOpen(m: string) {
    return this.state.modal.displayedModals.has(m as ModalType);
  }
}
</script>

<style lang="scss"></style>
